import api, { Command } from '../api';
import BaseStore from './base';
export class AuthStore extends BaseStore {
    constructor() {
        super({
            checking: false,
            loading: false
        });
    }
    /**
     * Проверяет, авторизирован ли текущий пользователь
     */
    async check() {
        this.update({ checking: true });
        try {
            const resp = await api.get(Command.Me);
            if (resp.username) {
                this.update({
                    session: {
                        username: resp.username,
                        roles: resp.roles
                    }
                });
                return true;
            }
        }
        finally {
            this.update({ checking: false });
        }
        return false;
    }
    /**
     * Пытаемся авторизировать пользователя
     */
    async login(username, password) {
        this.update({
            loading: true,
            error: null
        });
        try {
            const resp = await api.post(Command.Login, { username, password });
            this.update({
                session: {
                    username: resp.username,
                    roles: resp.roles
                }
            });
        }
        catch (error) {
            this.update({ error });
        }
        finally {
            this.update({ loading: false });
        }
        return true;
    }
    /**
     * Выход текущего пользователя
     */
    async logout() {
        this.update({ session: null });
        // TODO вызвать метод API для удаления куки
    }
}
const auth = new AuthStore();
export { auth };
